// components/SearchBar/SearchBar.tsx
import React from 'react';

export const SearchBar = ({value, onChange}) => {
    return (
        <div className="relative bg-white text-sm w-full md:w-[380px] rounded-[20px]">
            <input
                type="text"
                value={value}
                onChange={(e) => onChange(e.target.value)}
                placeholder={'Tìm đơn hàng'}
                className="w-full pl-4 pr-10 py-2 bg-white border border-gray-200 rounded-[20px]"
            />
            <button className="absolute right-5 md:right-4 top-1/2 -translate-y-1/2">
                <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} stroke={'black'}
                          d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"/>
                </svg>
            </button>
        </div>
    );
};